<template>
  <div class="form-group">
    <strong class="label-holder">
      <label :for="id">{{ $t(label) }}</label>
    </strong>
    <div class="btns-area">
      <input
        v-model="inputValue"
        :type="type"
        class="register-btn text-uppercase form-control"
        :class="{ 'errorInput' : invalid }"
        :id="id"
        :placeholder="$t('payment.vehicle.your_reg')"
        @blur="$emit('change')"
        @keydown.space.prevent
        @keyup.enter="lookup(index)"
      />

      <button @click="lookup" type="button" class="logout-btn" :disabled="!inputValue">
        {{ $t('payment.vehicle.lookup') }}
        <i class="icon-search"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { call } from "vuex-pathify";

export default {
  name: "input-reg",
  props: {
    id: { type: String, default: "field", required: true },
    value: { required: true },
    type: { type: String, default: "text" },
    label: { type: String, required: true },
    index: { type: Number, required: true },
    invalid: { type: Boolean, default: false }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    lookupApi: call('payment/registrationLookup'),
    lookup() {
      this.lookupApi(this.index);
    }
  }
};
</script>